import * as React from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { cn } from "../../lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string; // Optional error message prop
}

const PasswordInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <div className="flex flex-col">
        <div className="relative flex items-center">
          <input
            type={showPassword ? "text" : "password"}
            className={cn(
              "flex-grow h-10 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
              {
                "border-red-500 focus-visible:ring-red-500": error, // Red border if there's an error
                "focus:border-red-500": error, // Red border on focus if there's an error
              },
              className
            )}
            ref={ref}
            {...props}
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute right-3"
          >
            {showPassword ? (
              <FaEyeSlash className="w-5 h-5 text-primary" />
            ) : (
              <FaEye className="w-5 h-5 text-primary" />
            )}
          </button>
        </div>
        {error && (
          <p className="mt-1 text-xs text-red-500">{error}</p> // Display error message
        )}
      </div>
    );
  }
);
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
